import React from "react";

import { NativeSelect, withStyles } from "@material-ui/core";

import InputBase from "@material-ui/core/InputBase";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const BootstrapInput = withStyles((theme) => ({
  root: {},
  input: {
    color: " #898C98",
    // fontWeight: "300",
    borderRadius: 3,
    position: "relative",
    height: "1.2rem",
    // backgroundColor: theme.palette.background.paper,
    border: "1px solid #E2E5EC;",
    fontSize: "0.825rem",
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["poppins-medium"].join(","),
    "&:focus": {},
  },
}))(InputBase);

const MNativeSelect = (props) => {
  const { options, nulloption } = props;

  return (
    <div className="kissht-select">
      <NativeSelect
        style={{ minWidth: props.minwidth }}
        id="demo-customized-select-native"
        IconComponent={KeyboardArrowDownIcon}
        {...props}
        input={<BootstrapInput />}
      >
        {nulloption ? (
          <option aria-label="" value="">
            {nulloption}
          </option>
        ) : null}
        {options &&
          Object.keys(options).map((key) => {
            return (
              <option value={key} key={key}>
                {options[key]}
              </option>
            );
          })}
      </NativeSelect>
    </div>
  );
};

export default MNativeSelect;
